const DEFAULT_GATEWAY_CONFIGS = {
    returnedSeriesLimit: 0,
    returnedDatapointsLimit: 0,
    tracingUIEnabled: false,
    collectionsAccess: 'disabled',
    serviceUIEnabled: false,
    sloUIEnabled: false,
    scrapeInterval: '15s',
    enableExternalServiceConfig: false,
    enableMetricsDDX: false,
    alertEntityUIEnabled: false
};

export { DEFAULT_GATEWAY_CONFIGS };
//# sourceMappingURL=gateway-config-model.js.map
